// Mirrors STANDALONE_WAIVER_LIMIT_TYPE_* in server/server/waivers/constants.py: the
// discriminator the standalone waiver 429 payload uses to tell the two rate limits apart.
export const LIMIT_TYPE = {
  // Per-company hard cap for the UTC day — the signer must contact the operator.
  DAILY: 'daily',
  // Transient per-link burst counter — the signer can retry in a few minutes.
  HOURLY: 'hourly',
};
